import React from 'react';

import { Dimensions } from 'react-native';
import { useNavigate } from 'react-router-dom';

import MainMenuLink from 'components/main-menu-link';
import { BackArrowHistory as BackArrow } from 'components/navigation/back-arrow';
import useMediaQuery from 'hooks/use-media-query';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useMenuContext } from 'state/menu';
import { useProductWizardContext } from 'state/product-wizard';
import { ProductWizardStep } from 'state/product-wizard/types';

import { ProductLayout } from './product-layout/product-layout';
import { LayoutContainer, LayoutContent } from './styled';

const ProductDetail: React.FC = () => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery('desktopLarge');
  const { currentStep } = useProductWizardContext();
  const { showStaticMenu } = useMenuContext();
  const useEnableShowPickerAspectsInStaticMenu = useFlag(
    LaunchDarklyFlag.ENABLE_SHOW_PICKER_ASPECTS_IN_STATIC_MENU
  );

  // Product customization has its own back button
  const showBackButton = currentStep !== ProductWizardStep.ProductCustomization;

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const windowHeight = Dimensions.get('window').height;

  // switch to <main></main> when imported from layout
  return (
    <LayoutContainer
      $isStatic={showStaticMenu && !useEnableShowPickerAspectsInStaticMenu}
      data-testid="product-detail"
    >
      <LayoutContent $windowHeight={windowHeight}>
        {isDesktop ? (
          <MainMenuLink onClick={handleBackButtonClick} />
        ) : (
          showBackButton && <BackArrow onClick={handleBackButtonClick} />
        )}
        <ProductLayout />
      </LayoutContent>
    </LayoutContainer>
  );
};

export default ProductDetail;
